import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../styles';

const useStyles = makeStyles((theme) => ({
  muiInput: {
    display: 'block',
    color: variables.richBlack,
    backgroundColor: variables.greyLight,
    border: 0,
    borderRadius: 8,
    width: '100%',
    height: 56,
    padding: 16,
  },
  input: {
    padding: theme.spacing(0),
  },
  inputFocused: {
    border: '1px solid black',
    borderRadius: 8,
  },
  inputError: {
    border: '1px solid red',

    '&:hover': {
      border: '1px solid red',
    },
  },
  errorDescription: {
    display: 'flex',
    color: variables.red,
    margin: theme.spacing(1, 0, 0, 0.5),
  },
}));

export default useStyles;
